
export default {
  name: 'CarouselControls',
  props: {
    isWhiteExtentions: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    buttonStyles () {
      if (this.isWhiteExtentions) {
        return 'carousel-control-white'
      } else {
        return ''
      }
    },
    leftStyle () {
      if (this.isWhiteExtentions) {
        return 'white-block-left'
      } else {
        return ''
      }
    },
    rightStyle () {
      if (this.isWhiteExtentions) {
        return 'white-block-right'
      } else {
        return ''
      }
    },
  },
}
